import { IMember } from "@wingspanhq/users/dist/lib/interfaces";
import type { onboardingApiSpec } from "@wingspanhq/wingspan-api-types";

export const selectorCanEnableTaxWithholdings = (
  monitoredEntity?: onboardingApiSpec.CustomerEntity,
  member?: IMember
) =>
  (monitoredEntity?.country === "US" ||
    member?.profile.address?.country === "US") ??
  true;
